import { useTranslation } from 'react-i18next'
import {
  LinkTag,
  Obj,
  currentPage,
  provideComponent,
  useDataItem,
} from 'scrivito'

import { BreadcrumbWidget } from './BreadcrumbWidgetClass'
import { objTitle } from '../../utils/objTitle'
import { BreadcrumbItem } from '@/Atomic/Atoms/BreadcrumbItem'
import { Breadcrumbs } from '@/Atomic/Molecules/Breadcrumbs'
import { getDataItemTitle } from '@/utils/dataClassMap'

provideComponent(BreadcrumbWidget, () => {
  const { t } = useTranslation()
  const currentPageObj = currentPage()
  if (!currentPageObj) return <nav aria-label="breadcrumb" />

  const breadcrumbItems = currentPageObj
    .ancestors()
    .filter((item): item is Obj => !!item && !item.get('hideInNavigation'))

  const dataItem = useDataItem()

  let rawCurrentBreadcrumbItem = getDataItemTitle(dataItem)

  if (!rawCurrentBreadcrumbItem) {
    rawCurrentBreadcrumbItem = objTitle(currentPageObj)
  }

  const translatedCurrentBreadcrumbItem = t(
    `components.breadcrumbs.${rawCurrentBreadcrumbItem}`,
  )

  let currentBreadcrumbItem = rawCurrentBreadcrumbItem
  if (!translatedCurrentBreadcrumbItem.includes('components.breadcrumbs.')) {
    currentBreadcrumbItem = translatedCurrentBreadcrumbItem
  }

  return (
    <Breadcrumbs className="mb-3">
      {breadcrumbItems.map((obj) => {
        if (objTitle(obj) === 'dashboard') return null

        return (
          <BreadcrumbItem
            key={obj.id()}
            component={LinkTag}
            componentProps={{ to: obj }}
          >
            {t(`components.breadcrumbs.${objTitle(obj)}`)}
          </BreadcrumbItem>
        )
      })}
      <BreadcrumbItem active>{currentBreadcrumbItem}</BreadcrumbItem>
    </Breadcrumbs>
  )
})
